/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';


const Page = (props) => (
  <div className="cmp-page" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
    {props.children}
  </div>
);
Page.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default Page;
